import React from "react";
import ExperinceCard from "./templates/ExperinceCard";
import TimeCard from "./templates/TimeCard";
import { useNavigate } from "react-router-dom";
import DeadLineCard from "./templates/DeadLineCard";
import _ from "lodash";
import LocationCard from "./templates/LocationCard";

const CarrerCard = ({
  jobtitle,
  jobexperince,
  jobtype,
  index,
  id,
  deadline,
  location,
}) => {
  const isEven = (value) => {
    return Number(value) % 2 == 0 ? "even" : "add";
  };
  const navigate = useNavigate();
  return (
    <div
      className={`py-4 flex items-center border rounded-2xl w-full my-4 carrer-card cursor-pointer ${
        isEven(index) == "even" ? "carrer-card-even" : "carrer-card-odd"
      }`}
      onClick={() => navigate(`/careers/deatils/${id}`)}
    >
      <div className="w-full px-10">
        <div className="flex  justify-between items-center">
          <h2 className="my-3 text-xl font-semibold ">
            {" "}
            {_.capitalize(jobtitle)}
          </h2>
        
        </div>
        <DeadLineCard>{deadline}</DeadLineCard>
        <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-3 max-sm:grid-cols-2 lg:gap-20 md:gap-10 sm:gap-8 max-sm:gap-6 my-4">
          <ExperinceCard>{jobexperince}</ExperinceCard>
          <TimeCard>{jobtype}</TimeCard>
          <LocationCard>{location}</LocationCard>
        </div>
      </div>
    </div>
  );
};

export default CarrerCard;
